namespace app.legacy {
    "use strict";

    import IStateService = angular.ui.IStateService;
    
    export class LegacyController {

        public currentStateChangeRequest;
        
        public hide: boolean = false;

        /** @ngInject **/
        constructor(private legacyCommunicationService: LegacyCommunicationService,
                public frameUrl: string, public parentUrl:string, private $rootScope: angular.IRootScopeService,
                private $sce: ng.ISCEService, private $timeout: angular.ITimeoutService, private $stateParams: angular.ui.IStateParamsService,
                private properties: app.support.constants.Properties) {
            this.currentStateChangeRequest = legacyCommunicationService.getCurrentStateChangeRequest();
            this.$rootScope.$on("legacyRouteChangedToRefresh", (event, data) => {
                this.frameUrl = this.$sce.trustAsResourceUrl(properties.apiUrl + "/" + $stateParams['context'] + "/#/" + data["url"]);
                this.hide = true;
                this.$timeout(() => {
                    this.hide = false;
                }, 1);
            });
        }
    }

    angular
        .module('app.legacy')
        .controller('app.legacy.LegacyController', LegacyController);
}